const errorMessages = {
    "any.required": () => '"${label}" harus diisi.',
    "any.empty": () => '"${label}" harus diisi.',
    "string.email": () => 'Format "${label}" tidak valid.',
    "string.regex.base": () => 'Format "${label}" tidak sesuai.',
    "number.base": () => '"${label}" harus diisi dalam format angka.',
    "string.uri": () => '"${label}" harus dalam format uri.',
    "date.base": () => '"${label}" harus diisi dalam format tanggal.',
    "object.min": () => '"${label}" harus diisi.',
    "array.includesRequiredKnowns": () => '"${label}" harus diisi',
    "object.base": () => '"${label}" harus diisi.',
    "any.allowOnly": () => '"${label}" harus diisi.',
    "number.min": () =>
        '"${label}" harus sama dengan atau lebih besar dari ${limit}.',
    "number.max": () =>
        '"${label}" harus sama dengan atau kurang besar dari ${limit}.',
    "string.min": () => '"${label}" harus di atas ${limit} karakter.',
    "string.max": () => '"${label}" harus di bawah ${limit} karakter.',
    "date.greater": () => '"${label}" harus setelah tanggal sebelumnya.',
    "date.min": () =>
        '"${label}" harus sama dengan atau setelah tanggal sebelumnya.'
  };
  
  export default errorMessages;
  